module.exports = __webpack_public_path__ + "static/logo-sticky-7628c52c9c6d4a13f9841c1b4e6daf74.svg";